// ponytail: FlaggedComment has no createdAt, so the flag time is the cuid timestamp. Upgrade path: store createdAt on FlaggedComment.
export function timestampFromCuid(id) {
  if (!id || id.length < 9) return null;
  const ms = parseInt(id.slice(1, 9), 36);
  if (!Number.isFinite(ms)) return null;
  const date = new Date(ms);
  return Number.isNaN(date.getTime()) ? null : date.toISOString();
}

export function latestFlaggedAt(...values) {
  const times = values
    .filter(Boolean)
    .map((value) => new Date(value).getTime())
    .filter((ms) => !Number.isNaN(ms));
  if (!times.length) return null;
  return new Date(Math.max(...times)).toISOString();
}
